<template>
  <div class="flex flex-col min-h-svh">
    <SkipToContent />
    <TheHeader />
    <main id="main-content" class="flex-1 relative z-1">
      <div class="bg-white min-h-full">
        <slot />
      </div>
    </main>
    <SiteSwitchComponent name="footer" />
    <TheSearchDrawer />
    <TheFormDrawer />
    <DevOnly>
      <DebugGrid />
    </DevOnly>
  </div>
</template>
